import React from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { finalChecklist } from '../data/content';
export function FinalCTA() {
  return <section className="w-full bg-brand-950 px-5 py-16 md:py-24" data-id="element-110" data-mp="c7k4huqyqhna">
      <div className="mx-auto max-w-3xl text-center" data-id="element-111" data-mp="84ns4ls0nhrs">
        <p className="text-sm font-extrabold uppercase tracking-wider text-mint-400" data-id="element-112" data-mp="87a0gnmqe1b2">
          Ready to Bring More Structure to Your Planning?
        </p>
        <h2 className="mt-3 text-balance text-[1.9rem] font-extrabold leading-tight text-white sm:text-5xl" data-id="element-113" data-mp="h6napiioitwu">
          Stop Starting Every Intervention Plan From a Blank Page.
        </h2>
        <p className="mt-5 text-lg leading-relaxed text-brand-100" data-id="element-114" data-mp="qv59xvbb8syd">
          You don't need another disconnected collection of sensory activities. You need a practical way to organize:
        </p>

        <ul className="mx-auto mt-8 grid max-w-2xl gap-2.5 text-left sm:grid-cols-2" data-id="element-115" data-mp="zwv8dl3m0s5n">
          {finalChecklist.map(item => <li key={item} className="flex items-center gap-3 rounded-2xl bg-brand-900 p-4 ring-1 ring-white/10" data-id="element-116" data-mp="2c5y7rheja7aq">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-cta text-cta-ink" data-id="element-117" data-mp="2h3zse6rlyeob">
                <CheckIcon className="h-4 w-4" strokeWidth={3.5} aria-hidden="true" data-id="element-118" data-mp="2m5724bdb9nxm" />
              </span>
              <span className="text-base font-bold uppercase tracking-wide text-white" data-id="element-119" data-mp="2v3iou2b241ks">{item}</span>
            </li>)}
        </ul>

        <p className="mt-10 text-lg font-bold text-white" data-id="element-120" data-mp="301k7wn8hg0w9">
          6 Premium Volumes · 35+ Planning Tools · 5 Professional Bonuses
        </p>
        <p className="mt-2 text-balance text-2xl font-extrabold text-cta sm:text-3xl" data-id="element-121" data-mp="34vex266ux82q">
          Get the Complete Roadmap™ Today for Just $27
        </p>

        <div className="mt-8" data-id="element-122" data-mp="3esjb1iqjtx8g">
          <CTAButton label="Get Instant Access to the Complete Roadmap™" data-id="element-123" data-mp="3etcm2vwjj8we" />
        </div>
        <p className="mt-4 flex items-center justify-center gap-1.5 text-sm font-medium text-brand-200" data-id="element-124" data-mp="3itmpq1wv1n83">
          <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-125" data-mp="1jolcubdgyfad" />
          One-time payment · Digital access · 7-day guarantee
        </p>
        <Countdown dark data-id="element-126" data-mp="1sgewi6oao646" />
      </div>
    </section>;
}